import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  EditorSelectorInput,
  EditorStingInput,
  EditorCheckboxInput,
  EditorMultiSelectorInput,
} from '../../../basicEditor/editorControls';
import { fieldPropType } from '../hooks';

function FieldProps({
  value, onChange, readOnly, alowedTables,
  allowedCtypes, tableFields, allowedFilters, allowedAggregates,
}) {
  const allowedFields = useMemo(
    () => (tableFields[value.table] || []).map((v) => ({ value: v, display_name: v })),
    [tableFields, value.table],
  );
  const displayAllowedFilters = useMemo(
    () => (allowedFilters[value.ctype] || []).map((v) => ({ value: v, display_name: v })),
    [allowedFilters, value.ctype],
  );
  return (
    <div className="containerField p-3 border rounded">
      <EditorStingInput
        controlId="field_expression_input"
        label="Expression"
        required
        description="Выражение, для получения поля. Как правило совпадает с полем таблицы"
        value={value.expression}
        readOnly={readOnly}
        onChange={(e, v) => onChange({ expression: v })}
      />
      <EditorSelectorInput
        controlId="field_table_input"
        label="Table"
        required
        description="Таблица, в которую входит поле"
        value={value.table}
        values={alowedTables}
        readOnly={readOnly}
        onChange={(e, v) => onChange({ table: v })}
      />
      <EditorStingInput
        controlId="field_alias_input"
        label="Alias"
        required
        description="Псевдоним (as {alias})"
        value={value.alias}
        readOnly={readOnly}
        onChange={(e, v) => onChange({ alias: v })}
      />
      <EditorSelectorInput
        controlId="field_ctype_input"
        label="Ctype"
        required
        description="Тип поля"
        value={value.ctype}
        readOnly={readOnly}
        values={allowedCtypes}
        onChange={(e, v) => onChange({
          ctype: v,
          hierarchical_key: null,
          filtered: allowedFilters[v] || [],
        })}
      />
      <EditorCheckboxInput
        controlId="field_mandatory_input"
        label="Mandatory"
        description="Ознака обов\'язковості поля. Якщо поле обов\'язкове - поле буде включено в запит незалежно від
        налаштувань користувача."
        value={value.mandatory}
        readOnly={readOnly}
        onChange={(e, v) => onChange({ mandatory: v })}
      />
      <EditorCheckboxInput
        controlId="field_key_input"
        label="Key"
        description="Ознака того, що це поле є ключовим. Ключове поле може бути використане в where та group_by"
        value={value.key}
        readOnly={readOnly}
        onChange={(e, v) => onChange({ key: v, calc: null })}
      />
      <EditorCheckboxInput
        controlId="field_ordered_input"
        label="Orderd"
        description="Ознака того, що даним полем можна сортувати."
        value={value.ordered}
        readOnly={readOnly}
        onChange={(e, v) => onChange({ ordered: v })}
      />
      <EditorCheckboxInput
        controlId="field_having_input"
        label="Having"
        description="Ознака того, що дане поле може бути включено в пропозицію having."
        value={value.having}
        readOnly={readOnly}
        onChange={(e, v) => onChange({ having: v })}
      />
      <EditorSelectorInput
        controlId="field_hierarhical_input"
        label="Hierarhical key"
        description="Ім\'я поля в цій таблиці, для побудови ієрархії. Наприклад, 'parent_id'. Може бути вказано лише для ctype='key'"
        value={value.hierarchical_key}
        values={allowedFields}
        readOnly={readOnly}
        onChange={(e, v) => onChange({ hierarchical_key: v })}
      />
      <EditorMultiSelectorInput
        controlId="field_filtered_input"
        label="Filtered"
        required
        description="Допустимі види порівняння."
        value={value.filtered}
        values={displayAllowedFilters}
        readOnly={readOnly}
        onChange={(e, v) => onChange({ filtered: v })}
      />
      <EditorSelectorInput
        controlId="field_calc_input"
        label="Calc"
        description="Список можливих агрегатних функцій для поля."
        value={value.calc}
        values={allowedAggregates}
        readOnly={readOnly || value.key}
        onChange={(e, v) => onChange({ calc: v })}
      />
    </div>
  );
}

FieldProps.propTypes = {
  value: fieldPropType,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  alowedTables: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    display_name: PropTypes.string,
  })).isRequired,
  allowedCtypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  tableFields: PropTypes.shape({}).isRequired,
  allowedFilters: PropTypes.shape({}),
  allowedAggregates: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

FieldProps.defaultProps = {
  value: '',
  readOnly: false,
  allowedFilters: {},
};

export default FieldProps;
